




































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {$, MixinUpload, PageCollection, pushByName, success} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import AreaDeRisco from '@/model/resource/AreaDeRisco'
import RiskAreaRequest from '@/model/request/RiskAreaRequest'
import FilterRiskArea from '@/components/filters/FilterRiskArea.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import RiskAreaResponse from '@/model/response/RiskAreaResponse'
import {FileObject} from 'image-compressor.js'
import PersisAreaDeRiscoRequest from '@/model/request/PersisAreaDeRiscoRequest'
import {UploadConfig} from '@/config/upload.config'
import {Role} from '../../enums/Role'

const metaInfo = () => ({
  title: $.t('view.manage.riskArea.title'),
})

@Component({
  components: {FilterToggle, FilterRiskArea},
  metaInfo,
})
export default class ManageRiskAreaListView extends Mixins(MixinFilter, MixinSelect, MixinUpload) {
  @Getter('auth/responsavel') user!: Responsavel
  @Getter('auth/role') role!: Role

  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  Role = Role
  filter = new RiskAreaRequest()
  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(AreaDeRisco, this.filter, 10)

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
      const csv = new PageCollection(AreaDeRisco, this.filter, null, null)

      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv(snakeCase($.t('view.reports.riskArea.title')))
    } else {
      await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.riskArea.title'),
          new RiskAreaResponse().$endpoint,
          this.filter,
          RiskAreaResponse,
          'RiskAreaResponse',
      ), 'download')
    }
  }

  @Watch('files')
  async filesEvent(files: FileObject[]) {
    if (!files || !files.length) return
    $.await.init('uploadCsv')

    const blueprint = AppConfig.csvBlueprint.riskArea
    const data = await Helper.csvToNormalizedData(files[0].file, blueprint)
    const notificarNoAppOrPainel = (item: any) => {
      if (item === '1') {
        return true
      }
      if (item === '0') {
        return false
      }
      $.await.done('uploadCsv')
      throw this.$snotify.error(this.$t('view.manage.riskArea.errorNotificar'))
    }

    const request = new PersisAreaDeRiscoRequest()
    request.areaDeRisco = data.map((item) => {
      const model = new AreaDeRisco()
      model.cepInicial = item.cepInicial
      model.cepFinal = item.cepFinal
      model.notificarNoApp = notificarNoAppOrPainel(item.notificarNoApp)
      model.notificarNoPainel = notificarNoAppOrPainel(item.notificarNoPainel)
      model.responsavel = this.user
      return model
    })

    try {
      await request.persistAreaDeRisco()
    } finally {
      $.await.done('uploadCsv')
    }

    Helper.success('system.success.persist')

    await this.populate()
  }
}
